import styled from 'styled-components'

export const Wrapper = styled.div`
  margin-top: 24px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 100%;
  height: 100%;

  h1 {
    line-height: normal;
    margin-bottom: 0;
  }

  button {
    align-self: flex-end;
  }
`

export const Inputs = styled.div`
  display: flex;
  align-items: end;
  margin-bottom: 12px;

  div:last-child {
    margin: 0;
  }
`

export const Buttons = styled.div`
  display: flex;

  justify-content: flex-end;
  button:last-child {
    margin-left: 10px;
  }
`

export const AddPatient = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  max-width: 500px;

  & div {
    display: flex;
    justify-content: space-between;
    align-items: center;
    cursor: pointer;
    color: ${({ theme }) => theme.colors.primary};
    font-size: ${({ theme }) => theme.font.sizes.small};
    & svg {
      width: 14px;
      height: 14px;
      margin-right: 4px;

      & path {
        fill: ${({ theme }) => theme.colors.primary};
        stroke: ${({ theme }) => theme.colors.primary};
      }
    }
  }

  h5 {
    margin-bottom: 15px;
  }
`

export const SearchInputWrapper = styled.div`
  display: flex;
  height: fit-content;
  position: relative;
  max-width: 25rem;

  button {
    position: absolute;
    width: 51px;
    display: flex;
    border-radius: ${({ theme }) =>
      `0 ${theme.border.radius.xsmall} ${theme.border.radius.xsmall} 0`};
    justify-self: flex-start;
    align-self: flex-end;
    right: 0;

    span {
      width: 30px;
      height: 30px;
    }

    svg {
      height: 30px;
      width: 30px;

      path {
        height: 30px;
        width: 30px;
        fill: white;
        opacity: 1;
      }
    }
  }
`

export const NotFoundPatientMessage = styled.div`
  display: flex;
`
